import React from 'react';

const NearbyContent = props => {
  const { campgrounds } = props;
  return (
    <React.Fragment>
      <ul className="flex flex-col w-full">
        <li className="flex justify-between w-full mb-1 text-base text-gray-900">
          <span className="text-lg font-medium">Campgrounds</span>
          <span className="text-lg font-medium">Location</span>
        </li>
        {campgrounds.map(camp => {
          const { title, parent_title, url } = camp;

          return (
            <li
              key={title}
              className="flex justify-between w-full mb-1 text-sm text-gray-900 md:text-base">
              <a href={url} title={title} className="no-underline hover:underline">
                {title}
              </a>
              <span className="text-gray-500">{parent_title}</span>
            </li>
          );
        })}
      </ul>
    </React.Fragment>
  );
};

export default NearbyContent;
